import { TemplateStep } from 'crono-fe-common/types/enums/templateStep';
import TemplateType from 'crono-fe-common/types/enums/templateType';
import { TemplateVariables } from 'crono-fe-common/types/template';
import * as Yup from 'yup';
import { CronoAttachment } from 'crono-fe-common/types/cronoAttachment';
import { FileContent } from 'use-file-picker';
import { Constants } from 'crono-fe-common/constants/constants';

export const validationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  subject: Yup.string(),
  content: Yup.string(),
});

export type TemplateFilter = 'Team' | 'Personal';

export interface TemplateInputs {
  title: string;
  subject: string;
  content: string;
  language: string;
  shared: boolean;
  type: TemplateType;
  step: TemplateStep;
  attachments: (CronoAttachment | FileContent)[];
}

export interface UpdateTemplateInputs {
  id: number;
  title: string;
  subject: string;
  language: string | null;
  content: string;
  shared: boolean;
  type: TemplateType;
}

export const initialValues: TemplateInputs = {
  title: '',
  subject: '',
  content: '',
  language: Constants.defaultLanguage,
  shared: false,
  type: TemplateType.EMAIL,
  step: TemplateStep.FIRST_TOUCH,
  attachments: [],
};

export type IVariable =
  | {
      variable: TemplateVariables | string;
      text: string;
      isAiVariable?: boolean;
    }
  | {
      variable: TemplateVariables | string;
      text: string;
      isAiVariable?: boolean;
      userBased: boolean;
      content: string | null;
    };

export function isFileContent(object: unknown): object is FileContent {
  return !!object && typeof object === 'object' && 'content' in object;
}
